import comms from '../../comms';
let isInitialized=false;
const formatPhone = (phone) => {
  const phoneNumber = phone.replace(/[^\d]/g, '');
  const match = phoneNumber.match(/^(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    return `(${match[1]}) ${match[2]}-${match[3]}`;
  }
  return phone;
};

const initializeSocket = async (socket, setJobDetails, setDriverDetails, userSettings, fleetSettings, socketCallbacks = {}) => {
  // If no socket was passed, create one
  if (!socket) {
    socket = await comms.connectSocket(fleetSettings.dispatchUri);
  }
  
  if (!socket) return null;
  
  // Setup socket handlers for dispatch functionality
  if (socketCallbacks) {
    comms.setupSocketHandlers(socket, socketCallbacks);
  }
 
  // Send initial command (LiveDispatch - require active connection)
  comms.sendSocket('START', { skipOfflineQueue: true });

  socket.on('Command', function (msg) {
    try {
      const parts = msg.split("|");
      
      // Send ACK for all messages with a message ID
      if (parts[0]) {
        comms.sendSocket("ACK|" + parts[0], { skipOfflineQueue: true });
      }

      const command = parts[1];

      // Handle PING message - respond with current GPS (not handled by setupSocketHandlers callbacks)
      if (command === 'PING') {
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(
            (position) => {
              const { latitude, longitude } = position.coords;
              comms.sendGPS(latitude, longitude, comms.mpsToMph(position.coords.speed));
            },
            (error) => {
              console.error('Error getting location for PING response:', error);
            },
            { enableHighAccuracy: true, timeout: 5000, maximumAge: 30000 }
          );
        }
      }

      // All command dispatch (STARTM, JOBM, JOBOM, START, DRIVER, MSG, etc.)
      // is handled by comms.setupSocketHandlers — no duplicate processing here

    } catch (e) {
      // Silently handle parse errors — setupSocketHandlers has its own parsing
    }
  });
  
  isInitialized=true;
  return () => {
    socket.off('Command');
  };
};

export { initializeSocket, formatPhone };
